import { createEffect, createEvent, sample } from 'effector'
import { path } from '../../libs'
export const logout = createEvent()

const navigateToLoginFx = createEffect(() => {
  window.location.href = path.login.entry()
})

sample({
  clock: logout,
  target: navigateToLoginFx,
})
